import { useState } from "react";
import { FormProvider } from "react-hook-form";
import { nameof } from "ts-simple-nameof";
import styles from "./BusinessInfoSection.module.scss";
import { useMyBusinessForm } from "../hooks/useMyBusinessForm";
import { IMyBusinessFormModel } from "../models/myBusinessFormModel";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { Icon, IconType } from "../../../../common/icons/Icon";

export const BusinessInfoSection = () => {
  const [isEditing, setIsEditing] = useState(false);

  const { form, business, hasExistingBusiness, isLoading, isSaving, onSubmit } =
    useMyBusinessForm({
      onSaved: () => setIsEditing(false),
    });

  const isAdding = !hasExistingBusiness;
  const showForm = isEditing || isAdding;

  const viewMode = (
    <div className={styles.viewMode}>
      <div className={styles.field}>
        <span className={styles.label}>Име на фирма</span>
        <span className={styles.value}>{business?.companyName || "—"}</span>
      </div>
      <div className={styles.field}>
        <span className={styles.label}>Булстат/ЕИК</span>
        <span className={styles.value}>{business?.bulstat || "—"}</span>
      </div>
      <div className={styles.field}>
        <span className={styles.label}>Адрес</span>
        <span className={styles.value}>{business?.address || "—"}</span>
      </div>
      <div className={styles.field}>
        <span className={styles.label}>Град</span>
        <span className={styles.value}>{business?.city || "—"}</span>
      </div>
      <div className={styles.field}>
        <span className={styles.label}>Държава</span>
        <span className={styles.value}>{business?.country || "—"}</span>
      </div>
      <div className={styles.field}>
        <span className={styles.label}>МОЛ</span>
        <span className={styles.value}>{business?.mol || "—"}</span>
      </div>
      <div className={styles.editRow}>
        <button
          type="button"
          className={styles.editBtn}
          onClick={() => setIsEditing(true)}
        >
          <Icon
            type={IconType.EditIcon}
            width="14px"
            height="14px"
            color="currentColor"
          />
          Редактирай
        </button>
      </div>
    </div>
  );

  const editMode = (
    <FormProvider {...form}>
      <form onSubmit={onSubmit} className={styles.editMode} noValidate>
        <DefaultInputField
          name={nameof<IMyBusinessFormModel>((x) => x.companyName)}
          label="Име на фирма"
          placeholder="ДжинксТек ЕООД"
          required
          width="100%"
        />
        <DefaultInputField
          name={nameof<IMyBusinessFormModel>((x) => x.bulstat)}
          label="Булстат/ЕИК"
          placeholder="123456789"
          required
          width="100%"
        />
        <DefaultInputField
          name={nameof<IMyBusinessFormModel>((x) => x.address)}
          label="Адрес"
          placeholder="ул. Георги Живков 4Б ет. 3"
          required
          width="100%"
        />
        <DefaultInputField
          name={nameof<IMyBusinessFormModel>((x) => x.city)}
          label="Град"
          placeholder="Варна"
          required
          width="100%"
        />
        <DefaultInputField
          name={nameof<IMyBusinessFormModel>((x) => x.country)}
          label="Държава"
          placeholder="България"
          required
          width="100%"
        />
        <DefaultInputField
          name={nameof<IMyBusinessFormModel>((x) => x.mol)}
          label="МОЛ"
          placeholder="Николай Николаев"
          required
          width="100%"
        />
        <div className={styles.formActions}>
          {hasExistingBusiness && (
            <DefaultButton
              label="Отказ"
              type="button"
              design="outline"
              onClick={() => setIsEditing(false)}
              disabled={isSaving}
            />
          )}
          <DefaultButton
            label={hasExistingBusiness ? "Запази" : "Добави"}
            type="submit"
            design="accent"
            loading={isSaving}
          />
        </div>
      </form>
    </FormProvider>
  );

  if (isLoading && !business) {
    return (
      <section className={styles.section}>
        <div className={styles.loadingPlaceholder}>Зарежда...</div>
      </section>
    );
  }

  return (
    <section className={styles.section}>
      {showForm ? editMode : viewMode}
    </section>
  );
};
